<main class="container container-size-sm section-inset-y">
  @if (block.text) {
    <div
      class="markdown-content"
      [innerHTML]="block.text | stripEmbed: cookies ?? undefined | safe"
      fstrDynamicContent
    ></div>
  }
</main>
